import Utils from "../shared/utils";

// models to loading from Server
import { DataModel } from "../shared/models/syncModel";
import { CircularInjectionHelper } from "./circularInjectionHelper";
import { ContentType } from "../shared/contentTypes";
import { CoreCOMService } from "./com.service";
import { IObjectObserver } from "./IObjectObserver";
import { ObjectObserver, ObjectObserverData } from "./objectObserver.service";

/** ObjectObserver Service for manage the data in storage and over internet */

export class ObjectObserverFactory {
  /** internal holder for created ObjectObserver */
  private static _object_observers /** : { [id: string] : ObjectObserver<T>; } */ = {};
  private static _generate_observer_id(contentType: ContentType, data: ObjectObserverData): string {
    let data_ext = "";
    if (!Utils.IsNull(data)) {
      data_ext = "_" + data.GetKey();
    }
    return contentType.toString() + data_ext;
  }

  /** GetObjectObserverByInjectionHelper */
  public static GetObjectObserverByInjectionHelper<T extends DataModel>(contentType: ContentType, helper: CircularInjectionHelper, data: ObjectObserverData = null): IObjectObserver<T> {
    let objObserver = ObjectObserverFactory._object_observers[ObjectObserverFactory._generate_observer_id(contentType, data)];
    if (Utils.IsNull(objObserver)) {
      objObserver = new ObjectObserver<T>(contentType, data, helper);
      // todo eventuell eine bindung erzeugen um die Artikel details zu global zu binden
      ObjectObserverFactory._object_observers[ObjectObserverFactory._generate_observer_id(contentType, data)] = objObserver;
    }
    return objObserver;
  }

  /** ContainsObjectObserver, check if its already in ram */
  public static ContainsObjectObserver(contentType: ContentType, data: ObjectObserverData = null): boolean {
    let objObserver = ObjectObserverFactory._object_observers[ObjectObserverFactory._generate_observer_id(contentType, data)];
    return !Utils.IsNull(objObserver);
  }

  /** ReleaseObjectObserver, make more ram free */
  public static ReleaseObjectObserver(contentType: ContentType, data: ObjectObserverData = null): Promise<void> {
    return ObjectObserverFactory.ReleaseObjectObserverByID(ObjectObserverFactory._generate_observer_id(contentType, data));
  }

  /** see ReleaseObjectObserver */
  public static ReleaseObjectObserverByObserver<T extends DataModel>(objObserver: IObjectObserver<T>): Promise<void> {
    const keys = Object.keys(ObjectObserverFactory._object_observers).find(key => ObjectObserverFactory._object_observers[key] === objObserver)
    if (keys.length > 0) {
      return ObjectObserverFactory.ReleaseObjectObserverByID(keys[0]);
    } else {
      return Promise.resolve();
    }
  }

  /** make more ram free */
  private static ReleaseObjectObserverByID(observer_id: string): Promise<void> {
    let objObserver = ObjectObserverFactory._object_observers[observer_id];
    if (!Utils.IsNull(objObserver)) {
      /** todo momentan kein release, da die observer weiterverwendet werden 
       * siehe objectObserverService in _GetManager vor dem aufruf RefreshObjectsFromServer
       * ein resolve, der der eventuell mit das problem ist, aber es triit immer beim get_server_data
       * auf. das muss genauer untersucht werden, bevor die funktion wieder freigegeben wird
       * Vorschlag, ein eigenen garbagecollector, jeder der es aufruft teil sich mit und
       * wenn es es releaset kann geprüft werden, ob er der letzte user war, sonst bleigt es erhalten
      */
      //return objObserver.Release();
      return Promise.resolve();
    } else {
      return Promise.resolve();
    }
  }

  /** DeleteLocalStoredDataObjectObserver, deletes the local storaged data and free the ram */
  public static DeleteLocalStoredDataObjectObserver(contentType: ContentType, helper: CircularInjectionHelper, data: ObjectObserverData = null): Promise<void> {
    const objObserver = ObjectObserverFactory.GetObjectObserverByInjectionHelper(contentType, helper, data);
    if (!Utils.IsNull(objObserver)) {
      return Promise.reject("No object observer for ContentType: " + contentType);
    }
    return objObserver.DeleteLocalStoredData()
  }

  /** Synchronisiert die aktuell geladenen Objekte mit dem Server */
  public static SynchronizeWithServer(coreCOMService: CoreCOMService): Promise<void> {
    // check has Internet
    if (!coreCOMService.environment.networkInformation.isOnline) {
      Promise.reject("no internet");
    }
    // aktuell geladene Observer ermitteln, danach durchlaufen
    // getrennte schleifen um nicht beim durchlaufen verändert zu werden
    const loadedObjObserver = new Array<string>();
    for (const key in ObjectObserverFactory._object_observers) {
      if (ObjectObserverFactory._object_observers.hasOwnProperty(key)) {
        loadedObjObserver.push(key);
      }
    }

    return new Promise<void>(async (resolve) => {
      // aktuell geladene Observer durchlaufen
      for (const key of loadedObjObserver) {
        const objObserver = ObjectObserverFactory._object_observers[key];
        if (objObserver.SynchronizingWithServer) {
          // erstens die Serverdaten abholen
          await objObserver.RefreshObjectsFromServer();
          // zweitens die nicht übertragenen Daten an den Server senden
          await objObserver.SynchronizeObjectsWithServer();
        }
      }
      resolve();
    });
  }

  /** Privat darf nicht genutzt werden, dafür ist die Statische Function GetObjectObserver */
  private constructor() {
  }
}
